export const ru = {
    active: 'Идет сбор данных.',
    'active-text': 'Доступны промежуточные результаты, они могут отличаться от финальных результатов.',
    brandlift: 'Исследование Brand Lift',
    cancel: 'Отмена',
    close: 'Закрыть',
    completed: 'Опрос завершен.',
    draft: 'Черновик.',
    'draft-text': 'Сбор данных начнётся после того, как исследование пройдёт модерацию.',
    moderation: 'Отправлено на модерацию.',
    'moderation-text': 'Сбор данных начнётся после того, как исследование пройдёт модерацию.',
    'more-info-link': 'Подробнее',
    params: 'Параметры исследования',
    reject: 'Исследование отклонено модерацией.',
    result: 'Результаты исследования',
    save: 'Сохранить',
    stop: 'Опрос остановлен.',
    'stop-budget': 'Прогнозируемый бюджет кампании меньше {budgetThreshold}{currencySymbol}.',
    'stop-budget-and-coverage': 'Прогнозируемые бюджет и охват аудитории меньше пороговых значений. {moreInfoLink}.',
    'stop-coverage': 'Прогнозируемый охват кампании меньше 2 млн.',
    'stop-research': 'Отменить исследование'
};
